<template>
  <v-app>
    <core-app-bar v-if="['Login'].indexOf($route.name)"/>

    <core-drawer v-if="['Login'].indexOf($route.name)"/>

    <core-view/>

    <!--<core-footer />-->
  </v-app>
</template>

<script>
  export default {
    components: {
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreView: () => import('@/components/core/View')
    }
  }
</script>
<style>
  .v-dialog > .v-card > .v-card__title {
    background-color: #009fe3;
    color: white;
    height: 70px;
    cursor: move;
  }
  .v-dialog > .v-card > .v-card__title > .headline {
    cursor: default;
  }
</style>
